import * as React from "react";
const SvgFiRrGalaxyAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-galaxy-alt_svg__a)">
      <path
        fill="#062147"
        d="M15 2a2 2 0 1 1 3.999-.001 2 2 0 0 1-4 .001M6.499 16.062a.997.997 0 0 0 1.366-.364 1 1 0 0 0-.364-1.366A5.02 5.02 0 0 1 5 10a7.985 7.985 0 0 1 7.109-7.951 1 1 0 0 0 .885-1.104A1.003 1.003 0 0 0 11.89.061 9.983 9.983 0 0 0 3 10a7.02 7.02 0 0 0 3.499 6.062m-3.392 3.269c-.491-.376-.96-.791-1.393-1.233a1.004 1.004 0 0 0-1.415-.015 1 1 0 0 0-.015 1.415c.5.51 1.041.988 1.607 1.421a.995.995 0 0 0 1.401-.187 1 1 0 0 0-.187-1.401zM7 20a2 2 0 1 0-.001 3.999A2 2 0 0 0 7 20M23.714 4.502a15 15 0 0 0-1.606-1.421 1 1 0 0 0-1.214 1.589c.489.374.958.789 1.394 1.233.195.2.455.3.714.3a1 1 0 0 0 .714-1.7zM12 16c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m0-2c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2m5.5-6.063a1.001 1.001 0 0 0-1.002 1.732A5.02 5.02 0 0 1 19 14.001a7.986 7.986 0 0 1-7.11 7.951 1.001 1.001 0 0 0 .109 1.994c5.175-.469 9-4.84 9-9.945a7.03 7.03 0 0 0-3.498-6.063zM12 23.946c-.038.003.036 0 0 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-galaxy-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGalaxyAlt;
